import { useNavigate } from 'react-router-dom';
import { LoginButton } from './LoginButton';
import './TopBar.css';

export const TopBar = ({ title, onBack, backLabel = '←', actions, extra, className = '' }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) onBack();
    else navigate(-1);
  };

  return (
    <header className={`topbar ${className}`}>
      <div className="topbar__left">
        {onBack && (
          <button className="topbar__back" onClick={handleBack} aria-label="Indietro">
            {backLabel}
          </button>
        )}
        <h1 className="topbar__title">{title}</h1>
      </div>
      
      <div className="topbar__center">
        {extra}
      </div>

      <div className="topbar__right topbar__actions">
        {actions}
      </div>
    </header>
  );
};
